export enum OrderEnum {
  ASC = 'asc',
  DESC = 'desc',
}
